import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import AddCompanionCard from './AddCompanionCard';

const CompanionsEmptyState = ({
  findLabel,
  inviteLabel,
  onFind,
  onInvite,
  subtitle,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2.25} alignItems="stretch">
          <Typography variant="h3">{title || t('companions.empty.title')}</Typography>
          <Typography color="text.secondary">
            {subtitle || t('companions.empty.subtitle')}
          </Typography>
          {onInvite ? <AddCompanionCard onClick={onInvite} /> : null}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            {onFind ? (
              <Button variant="contained" startIcon={<SearchIcon />} onClick={onFind}>
                {findLabel || t('companions.empty.find')}
              </Button>
            ) : null}
            {!onInvite && inviteLabel ? <Button variant="contained">{inviteLabel}</Button> : null}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CompanionsEmptyState;
